module.exports = __webpack_public_path__ + "img/rtap-system.37871fd9.png";